import { useEffect, useState } from "react";
import { CheckListItem } from "../../types/CheckListItem";
import { StyledDisplayCheckListPanel } from "./DisplayCheckListPanel.styles";
import { CheckBoxComponent } from "@syncfusion/ej2-react-buttons";
import { Container, Row } from "react-grid-system";
import {
  ColumnDirective,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  Grid,
  GridComponent,
  Inject,
  Resize,
} from "@syncfusion/ej2-react-grids";

interface IDisplayCheckListModalPanel {
  checkListName: string;
  jobNumber: string;
  onValidate?: (failed: boolean, value?: any) => void;
  checkListItems: CheckListItem[];
}

export const DisplayCheckListModalPanel: React.FC<
  IDisplayCheckListModalPanel
> = ({
  checkListName,
  jobNumber,
  checkListItems,
  onValidate,
}: IDisplayCheckListModalPanel) => {
  const [items, setItems] = useState(checkListItems);
  const [errors, setErrors] = useState("");

  let grid: Grid | null;

  const conditionCheckedTemplate = (props: any) => {
    return (
      <div>
        <CheckBoxComponent
          id="checkTest"
          checked={props.checked}
          onChange={(args: any) => {
            const updatedItems = [
              ...items.map((item) => {
                if (item.description === props.description) {
                  item.checked = args.target.checked;
                  item.notApplicable = !args.target.checked;
                }
                return item;
              }),
            ];
            console.log(`onclicked  ${JSON.stringify(updatedItems)}`);
            validate(updatedItems);
            setItems(updatedItems);
          }}
        />
      </div>
    );
  };

  const conditionNotApplicableTemplate = (props: any) => {
    return (
      <div>
        <CheckBoxComponent
          id="notApplicableTest"
          checked={props.notApplicable}
          onChange={(args: any) => {
            const updatedItems = [
              ...items.map((item) => {
                if (item.description === props.description) {
                  item.notApplicable = args.target.checked;
                  item.checked = !args.target.checked;
                }
                return item;
              }),
            ];
            console.log(`onclicked  ${JSON.stringify(updatedItems)}`);
            validate(updatedItems);
            setItems(updatedItems);
          }}
        />
      </div>
    );
  };

  useEffect(() => {
    if (items) {
      validate(items);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const validate = (checkListItems: CheckListItem[] | undefined) => {
    console.log(`onValidate  ${JSON.stringify(checkListItems)}`);
    if (items?.some((item) => !item.checked && !item.notApplicable)) {
      setErrors("Please enter all checklist items.");
      onValidate?.(true, []);
    } else {
      setErrors("");
      onValidate?.(false, checkListItems);
    }
  };

  const editSettings: EditSettingsModel = {
    allowEditing: true,
    allowAdding: false,
    allowDeleting: false,
    mode: "Normal",
  };

  return (
    <StyledDisplayCheckListPanel>
      <Container fluid>
        <Row align="stretch">
          <GridComponent
            dataSource={items}
            id="GridCheckList"
            height={320}
            //allowPaging={true}
            allowTextWrap={true}
            allowResizing={true}
            ref={(g: GridComponent) => (grid = g)}
            editSettings={editSettings}
            gridLines="Both"
            //load={load}
            //actionComplete={onActionComplete}
          >
            <ColumnsDirective>
              <ColumnDirective
                field="description"
                headerText="Description"
                type="string"
                isPrimaryKey={true}
              />
             {/*  <ColumnDirective
                field="checked"
                headerText="Yes"
                width="70"
                editType="booleanedit" 
                allowEditing={true}
              />
              <ColumnDirective
                field="notApplicable"
                headerText="N/A"
                width="70"
                editType="booleanedit"
                allowEditing={true}
              /> */}
               <ColumnDirective
                field="checked"
                headerText="Yes"
                width="70"
                template={conditionCheckedTemplate}
              />
              <ColumnDirective
                field="notApplicable"
                headerText="N/A"
                width="70"
                template={conditionNotApplicableTemplate}
              />
            </ColumnsDirective>
            <Inject services={[Edit, Resize]} />
          </GridComponent>
        </Row>
        <Row align="stretch">
          <h6 style={{ color: "red" }}>{errors}</h6>
        </Row>
      </Container>{" "}
    </StyledDisplayCheckListPanel>
  );
};
